export default __webpack_public_path__ + "static/media/8.326ba80a.jpg";